import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

const controlStyles = {
    borderRadius: '1px solid black',
    color: 'white',
    width: '100%',
};

const ControlComponent = (props) => (
    <div style={controlStyles}>
        <components.Control {...props} />
    </div>
);

const PermissionsDropdown = ({ getPermissionID, modalInfo }) => {
    const [permissions, setPermissions] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        const getPermissions = async () => {
            const permissionFromServer = await fetchPermissions();
            setPermissions(permissionFromServer);
        };

        if (modalInfo) {
            const [permissionIDList, permissionNameList, permissionTypeList] = [
                modalInfo.permissionIDList.split(','),
                modalInfo.permissionNameList.split(','),
                modalInfo.permissionTypeList.split(','),
            ];
            const merger = permissionIDList.map((node, index) => ({
                value: node,
                label: `${permissionNameList[index]} - ${permissionTypeList[index]}`
            }));
            setSelectedOption(merger)
        }

        getPermissions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalInfo]);

    // Fetch Permissions
    const fetchPermissions = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/getpermissionlist'
        );
        const data = await res.json();

        return data.PermissionList;
    };

    const options = permissions.map((permission, index) => {
        return {
            value: permission.permissionID,
            label: permission.permissionName + " - " + permission.permissionType
        }
    })

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);

        if (selectedOption) {
            getPermissionID(
                Array.isArray(selectedOption)
                ? selectedOption.map((item) => item.value)
                : null
            )
        }
    };

    return (
        <Select
            closeMenuOnSelect={false}
            placeholder={'Select permission...'}
            components={{ Control: ControlComponent }}
            value={selectedOption}
            onChange={handleChange}
            options={options}
            isMulti
            isClearable
        />
    );
};

export default PermissionsDropdown;
